/* ── HAYLOU CI — theme.js ── */
(function(){
  /* Header scroll */
  const header = document.querySelector('.site-header');
  if(header){
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  /* Mobile menu */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if(hamburger && mobileNav){
    hamburger.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      const spans = hamburger.querySelectorAll('span');
      if(mobileNav.classList.contains('open')){
        spans[0].style.transform = 'rotate(45deg) translate(5px,5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px,-5px)';
      } else {
        spans.forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
      }
    });
    document.addEventListener('click', (e) => {
      if(!hamburger.contains(e.target) && !mobileNav.contains(e.target)){
        mobileNav.classList.remove('open');
        hamburger.querySelectorAll('span').forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
      }
    });
  }

  /* FAQ accordion */
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if(!isOpen) item.classList.add('open');
    });
  });

  /* Reviews auto-scroll */
  const track = document.querySelector('.reviews-track');
  if(track){
    let pos = 0;
    let isPaused = false;
    track.addEventListener('mouseenter', () => isPaused = true);
    track.addEventListener('mouseleave', () => isPaused = false);
    setInterval(() => {
      if(isPaused) return;
      pos += 0.5;
      if(pos >= track.scrollWidth - track.clientWidth) pos = 0;
      track.scrollLeft = pos;
    }, 16);
  }

  /* Video placeholder */
  const playBtn = document.querySelector('.play-btn');
  if(playBtn){
    playBtn.addEventListener('click', () => {
      const wrap = playBtn.closest('.video-wrap');
      const videoId = wrap.dataset.videoId;
      if(videoId){
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;';
        wrap.querySelector('.video-placeholder').replaceWith(iframe);
      }
    });
  }

  /* Product gallery thumbnails */
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = document.querySelector('.product-main-img img');
      if(mainImg && thumb.querySelector('img')){
        mainImg.src = thumb.querySelector('img').src;
      }
    });
  });

  /* Quantity buttons */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-input').querySelector('.qty-num');
      let val = parseInt(input.value) || 1;
      if(btn.dataset.action === 'minus') val = Math.max(1, val - 1);
      if(btn.dataset.action === 'plus') val++;
      input.value = val;
    });
  });

  /* Newsletter form */
  const newsletterForm = document.querySelector('.newsletter-form');
  if(newsletterForm){
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = newsletterForm.querySelector('.btn-subscribe');
      btn.textContent = '✓ Abonné !';
      btn.style.background = '#25D366';
      setTimeout(() => {
        btn.textContent = "Je m'abonne";
        btn.style.background = '';
        newsletterForm.reset();
      }, 3000);
    });
  }

  /* Add to cart button feedback */
  document.querySelectorAll('.btn-cart, .btn-add-to-cart').forEach(btn => {
    btn.addEventListener('click', function(e){
      const originalText = this.textContent;
      this.textContent = '✓ Ajouté !';
      this.style.background = '#25D366';
      setTimeout(() => {
        this.textContent = originalText;
        this.style.background = '';
      }, 2000);
    });
  });

  /* Variant selection */
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.variant-options');
      parent.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* Animate on scroll */
  if('IntersectionObserver' in window){
    const els = document.querySelectorAll('.product-card,.feature-card,.cat-card,.trust-item,.review-card');
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, {threshold:0.1});
    els.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity .5s ease, transform .5s ease';
      obs.observe(el);
    });
  }
})();
